import type { CompanySortOptions } from '@/api/v4/organization.api';
import type { HeaderCellConfig } from '../../ui/table/table.types';
import { colors } from '@/theme/colors';

export const companiesHeaders: HeaderCellConfig<CompanySortOptions>[] = [
  {
    columnKey: 'companies',
    sortKey: 'name',
    showCheckbox: true,
    defaultSortDirection: 'asc',
    bgColor: colors.basics.canvas,
  },
  {
    columnKey: 'tags',
    withSort: false,
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'projects',
    sortKey: 'listingCount',
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'founded',
    sortKey: 'yearEstablished',
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'fundingStage',
    sortKey: 'fundingStage',
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'capitalRaised',
    sortKey: 'capitalRaised',
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'lastModified',
    align: 'center',
    sortKey: 'lastEditedDate',
    bgColor: colors.basics.canvas,
    padding: '30px 10px 20px 10px',
  },
  {
    columnKey: 'action',
    hideLabel: true,
    bgColor: colors.basics.canvas,
  },
];
